export const NEUROSCALE_LINKS = {
  terms: "https://neuroscale.ai/terms",
  privacy: "https://neuroscale.ai/privacy",
  status: "https://status.neuroscale.ai",
  docs: "https://docs.neuroscale.ai",
} as const;

